import { Injectable } from '@angular/core';
import { GridLayoutService } from '@irb-common/interfaces/grid-layout.service';
import { ImportModelCategoryResultDialogComponent } from '@irb/irb-clients/import-model-category-result-dialog/import-model-category-result-dialog.component';

@Injectable({
    providedIn: 'root'
})
export class ImportModelCategoryResultGridLayoutService implements GridLayoutService<ImportModelCategoryResultDialogComponent> {
    constructor() {}

    getFrameworkComponents() {
        return {};
    }

    getColumnDefs() {
        return [{
            headerName: 'Entity',            
            field: 'entity',
            maxWidth: 140,
            flex: 1,
            sort:'asc',
            cellRenderer: 'cellRendererFormatter'
        },
        {
            headerName: 'Error Condition',
            field: 'errorDesc',
            cellRenderer: 'cellRendererFormatter',
            maxWidth: 331,
            flex: 3
        },
        {
            headerName: 'Line Number',
            field: 'lineNumber',
            maxWidth: 120,
            flex: 1
        }];
    }
}
